module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMBAMAAABYTmoeAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAALVBMVEUAAACvr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+UlzM1AAAADnRSTlMAaUL5JO0P2AO6k5S72bCpdYEAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAALklEQVQI12NgYBBgYGAyYGBwfcDAVveAofPdA4Z1QLwPiHuAmO3eA7AcWA2DAABvwg+wVkY1pgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/left-grey5.png
// module id = 784
// module chunks = 0 1 2 3 4